import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'

export default function Invitation() {
    const [templates, setTemplates] = useState([]);
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [preview, setPreview] = useState(null);
    const [alertMsg, setAlertMsg] = useState("");
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [membretype, setMembertype] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        let company_id = localStorage.getItem('mem_company_id');
        fetch("get_templates.php", {
            method: 'POST',
            body: new URLSearchParams({
                company_id: company_id
            })
        })
            .then(res => res.json())
            .then(data => {
                setTemplates(data);
            });

    }, []);

    const sendInvitation = () => {
        document.getElementById('waitloader').style.display = 'block';
        document.getElementById('waitloaderinner').style.display = 'block';
        document.getElementById('loadtext').textContent = 'Please wait.. We are sending yopur mail.'
        let company_id = localStorage.getItem('mem_company_id');
        let company_email = localStorage.getItem('useremail');
        let company_name = localStorage.getItem('mem_company_name');
        const data = {
            title: document.getElementById("invitation_title").value,
            recipient_name: document.getElementById("recipient_name").value,
            recipient_email: document.getElementById("recipient_email").value,
            template_id: document.getElementById("template").value,
            event_date: document.getElementById("event_date").value,
            event_time: document.getElementById("event_time").value,
            event_location: document.getElementById("event_location").value,
            message: document.getElementById("msgfield").value,
            company_id: company_id,
            company_email: company_email,
            company_name: company_name
        };

        fetch("save_invitation.php", {
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(res => res.text())
            .then(result => {
                console.log(result);
                showAlert(result.message);
                document.getElementById('waitloader').style.display = 'none';
                document.getElementById('waitloaderinner').style.display = 'none';
                document.getElementById('loadtext').textContent = ''
                document.getElementById("invitation_title").value = ''
                document.getElementById("recipient_name").value = ''
                document.getElementById("recipient_email").value = ''
                document.getElementById("template").value = ''
                document.getElementById("event_date").value = ''
                document.getElementById("event_time").value = ''
                document.getElementById("event_location").value = ''
                document.getElementById("msgfield").value = ''
            });

    }

    
    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg("");
        localStorage.setItem('communications', 'invitation');
        navigate('/redirect_communications');
    };

    const loadTemplate = (templateId) => {

        if (templateId === "") return;

        fetch("get_template_details.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: "template_id=" + templateId
        })
            .then(res => res.json())
            .then(data => {

                setSubject(data.subject);
                setMessage(data.body);

            });

    }

    const previewInvitation = () => {

        let obj = {
            template_id: document.getElementById("template").value,
            recipient_name: document.getElementById("recipient_name").value,
            invitation_title: document.getElementById("invitation_title").value,
            event_date: document.getElementById("event_date").value,
            event_time: document.getElementById("event_time").value,
            event_location: document.getElementById("event_location").value,
            message: document.getElementById("msgfield").value
        };

        fetch("preview_invitation.php", {
            method: "POST",
            body: JSON.stringify(obj)
        })
            .then(res => res.json())
            .then(data => {
                setPreview(data);
            });

    }
    return (
        <div>
            <h2 className='innerpage_heading'>Invitation</h2>
            <div className='vl_dsh_formnholder halfwidth'>
                <h3 className='sectionlabel'>Create Invitation</h3>
                <div className='formfieldcommon'>
                    <label>Template</label>
                    <select id="template" onChange={(e) => loadTemplate(e.target.value)}>
                        <option value="">Select Template</option>

                        {templates.map((t) => (
                            <option key={t.id} value={t.id}>
                                {t.template_name}
                            </option>
                        ))}

                    </select>
                </div>

                <div className='formfieldcommon'>
                    <label>Event Title</label>
                    <input id="invitation_title"
                        type="text"

                    />
                </div>
                <div className='formfieldcommon'>
                    <label>Reicipient Name</label>
                    <input type="text" id="recipient_name" />
                </div>
                <div className='formfieldcommon'>
                    <label>Recipient Email</label>
                    <input type="email" id="recipient_email" />
                </div>

                <div className='formfieldcommon'>
                    <label>Event Date</label>
                    <input type="date" id="event_date" />
                </div>
                <div className='formfieldcommon'>
                    <label>Event Time</label>
                    <input type="time" id="event_time" />
                </div>
                <div className='formfieldcommon'>
                    <label>Location / Meeting Link</label>
                    <input type="text" id="event_location" />
                </div>
                <div className='formfieldcommon'>
                    <label>Message</label>
                    <textarea id="msgfield"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        rows="8"
                    ></textarea>
                </div>
                <div className='vl_dsh_buttonholder'>
                    <button className="greenbutton pull_left mr-10" onClick={previewInvitation}>Preview</button>
                    <button className="pull_left" onClick={sendInvitation}>Send Invitation</button>
                </div>

                {preview && (

                    <div className="email_preview_box">

                        <h3>Email Preview</h3>

                        <h4>{preview.subject}</h4>

                        <div
                            className="preview_body"
                            dangerouslySetInnerHTML={{ __html: preview.body }}
                        ></div>

                    </div>

                )}
            </div>
            {showAlertBox && (
                <div className='vl_dsh_popup_vis'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>
                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}
            <div className='loaderpop' id='waitloader'>
                <div className='loader_inner' id="waitloaderinner">
                    <p id="loadtext"></p>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div >
    )
}
